import { useState, useEffect, PropsWithChildren } from 'react'
import { useVersion } from '../hooks/useVersion'

interface Props {
  migration: (version: string, previousVersion?: string | null) => Promise<void>
}

export const Migration = ({
  migration,
  children
}: PropsWithChildren<Props>) => {
  const [ready, setReady] = useState(false)
  const { version, previousVersion } = useVersion()

  useEffect(() => {
    migration(version, previousVersion).finally(() => {
      setReady(true)
    })
  }, [migration, previousVersion, version])

  return <>{ready ? children : null}</>
}
